module.exports = __webpack_public_path__ + "static/media/no_mobile_logo.0f174ebc.svg";